module.exports = __webpack_public_path__ + "static/media/Australia.3f16eee6.svg";